import React, { useEffect, useMemo, useState } from "react";
import {
  CarouselMainContainer,
  CourierName,
  MatchFoundContainer,
  MatchFoundHeaderContainer,
  MatchFoundTitleText,
  StyledCarousel,
  TrackingNumberContainer,
  TrackingNumberText,
} from "./styles";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks/redux";
import { convertUtcToLocal } from "../../../utils/helpers/convertUtcToLocal";
import PrematchModal from "../Modal/PrematchModal";
import { Form } from "antd";
import { PrematchedFoundItems } from "../../../types/PreMatchedFoundItems";
import PreMatchFoundItemCard from "./PreMatchFoundItemCard";
import { FoundItemCardType } from "../../../types/FoundItemTypes";
import { setPrematchModal } from "../../../redux/features/report/reportSlice";
import { LostStatuses } from "../../../types/LostStatuses";
import { PaymentStatus } from "../../../types";
import { shipMatchEnabled } from "../../../utils/constants";

const PreMatchFoundItem: React.FC = () => {
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useAppDispatch();
  const [selectedItem, setSelectedItem] = useState<PrematchedFoundItems | null>(null);
  const [form] = Form.useForm();

  const { report, status, error, prematchModal } = useAppSelector((state) => state.report);
  const preMatchedFoundItems = useAppSelector((state) => state.report.preMatchedFoundItems);

  useEffect(() => {
    if (report?.foundItem?.id) {
      setSelectedItem(report?.foundItem as PrematchedFoundItems);
    }
  }, [report, preMatchedFoundItems]);

  const carouselSettings = {
    dots: false,
    arrows: true,
    slidesToShow: 5.85,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1740,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1540,
        settings: {
          slidesToShow: 4.4,
        },
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3.5,
        },
      },
      {
        breakpoint: 1130,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.7,
        },
      },
      {
        breakpoint: 880,
        settings: {
          slidesToShow: 2.4,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2.1,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1.8,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.5,
        },
      },
      {
        breakpoint: 425,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const handleItemClick = (item: PrematchedFoundItems) => {
    setSelectedItem(item);
    dispatch(setPrematchModal({ isOpen: true }));
  };

  const handleModalCancel = () => {
    dispatch(setPrematchModal({ isOpen: false }));
    if (!report?.foundItem?.id)
      setSelectedItem(null);
    form.resetFields();
  };

  const renderPreMatchTitleText = useMemo(() => {
    if (report?.status !== undefined && report?.status < LostStatuses.LFNotified && report?.status !== LostStatuses.Deleted) {
      return "Possible Potential Match(es)";
    }
    return "Final Match Done";
  }, [report?.status]);

  const courierName = useMemo(() => {
    return report?.payment?.find((payment) => payment.status === PaymentStatus.Succeeded)?.shippingOption?.courier?.name || "";
  }, [report?.payment]);

  return (
    <MatchFoundContainer>
      <MatchFoundHeaderContainer>
        <MatchFoundTitleText>{renderPreMatchTitleText}</MatchFoundTitleText>
        {report?.trackingNumber && courierName && <TrackingNumberContainer>
          <CourierName>
            Courier: <b>{courierName}</b>
          </CourierName>
          <TrackingNumberText>
            Tracking No: <b>{report?.trackingNumber}</b>
          </TrackingNumberText>
        </TrackingNumberContainer>}
      </MatchFoundHeaderContainer>

      <CarouselMainContainer>
        {!report?.foundItem?.id && (
          <StyledCarousel {...carouselSettings} draggable arrows infinite={false}>
            {preMatchedFoundItems &&
              preMatchedFoundItems?.length > 0 &&
              preMatchedFoundItems?.map((item: PrematchedFoundItems, index, arr) => {
                return (
                  <div key={index} >
                    <PreMatchFoundItemCard handleItemClick={() => handleItemClick(item)} status="found_item" selectedItem={selectedItem} item={item} />
                  </div>
                );
              })}
          </StyledCarousel>
        )}

        {report?.foundItem?.id && (
          <div>
            <PreMatchFoundItemCard handleItemClick={() => handleItemClick(selectedItem as PrematchedFoundItems)} status={FoundItemCardType.Found_Item_Done} selectedItem={selectedItem} item={selectedItem as PrematchedFoundItems} cardType={FoundItemCardType.Matched} />
          </div>
        )}
      </CarouselMainContainer>

      {prematchModal?.isOpen && <PrematchModal isMarkModalOpen={prematchModal?.isOpen} handleMarkCancel={handleModalCancel} handleItemClick={handleItemClick} form={form} isFinalMatch={!!report?.foundItem?.id} selectedItem={selectedItem} />}
    </MatchFoundContainer>
  );
};

export default PreMatchFoundItem;
